const initialState = {}

// Parallel ranges can finish out of order; keep days in range order and only report the
// contiguous loaded prefix so later dates are never treated as loaded before they are.
const applyRangeDone = (calendar, { range_start: rangeStart, range_end: rangeEnd, days }) => {
  const previousDays = calendar?.days || []

  if (!calendar?.ranges) {
    return { lastLoadedDate: rangeEnd, days: previousDays.concat(days) }
  }

  const loadedRanges = [...calendar.loadedRanges, rangeStart]
  const firstUnloadedIndex = calendar.ranges.findIndex(([start]) => !loadedRanges.includes(start))
  const contiguousCount = firstUnloadedIndex === -1 ? calendar.ranges.length : firstUnloadedIndex

  return {
    ranges: calendar.ranges,
    loadedRanges,
    lastLoadedDate: contiguousCount > 0 ? calendar.ranges[contiguousCount - 1][1] : null,
    days: [
      ...previousDays.filter(({ date }) => date < rangeStart),
      ...days,
      ...previousDays.filter(({ date }) => date >= rangeStart)
    ]
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_CALENDAR_REQUEST':
      return {
        ...state,
        options: {
          calendarStatus: 'loading'
        },
        [action.payload.monthId]: {
          status: 'loading',
          ranges: action.payload.ranges,
          loadedRanges: [],
          lastLoadedDate: null,
          days: []
        }
      }

    case 'FETCH_CALENDAR_RANGE_DONE':
      return {
        ...state,
        options: {
          calendarStatus: 'loading'
        },
        [action.payload.monthId]: {
          status: 'loading',
          ...applyRangeDone(state[action.payload.monthId], action.payload)
        }
      }

    case 'FETCH_CALENDAR_DONE': {
      const calendar = state[action.payload.monthId]
      // A user swap clears the month. Don't recreate it without days: selectors
      // read calendar.days and throw while rendering the booking page.
      if (!calendar || !Array.isArray(calendar.days)) return state

      return {
        ...state,
        options: {
          calendarStatus: 'ready'
        },
        [action.payload.monthId]: {
          ...calendar,
          status: 'ready',
          receivedAt: Date.now(),
          diagnostic_data: action.payload.diagnosticData
        }
      }
    }

    case 'FETCH_CALENDAR_FAIL':
      return {
        ...state,
        options: {
          calendarStatus: 'error'
        },
        [action.payload.monthId]: {
          status: 'error',
          days: []
        }
      }

    case 'CLEAR_CALENDAR_DATA':
      return initialState

    default:
      return state
  }
}
